import React from 'react';
import { Box, SpacingStack } from '@withjoy/joykit';
import { SurveyStepProps } from '@shared/components/EventForm/components/presentational/steps/types';
import { GuestNameSummary } from './GuestNameSummary';
import { AttendanceSummary } from './AttendanceSummary';
import { ContactInfoSummary } from './ContactInfoSummary';
import { SurveyResponsesSummary } from './SurveyResponsesSummary';

type AnswersSummaryProps = Pick<SurveyStepProps, 'formState' | 'settings' | 'formData' | 'guestInfo'>;

export const AnswersSummary = ({ formState, settings, formData, guestInfo }: AnswersSummaryProps) => {
  const { attendanceValue, contactValues, formValues } = formState;

  const hasContactInfo = contactValues.firstName || contactValues.lastName || contactValues.email || contactValues.phoneNumber;
  const hasSurveyAnswers = Object.keys(formValues).length > 0;

  return (
    <Box
      marginTop="24px"
      marginBottom="24px"
      padding="20px"
      backgroundColor="mono2"
      borderRadius="8px"
    >
      <SpacingStack gap="1.5rem">
        {guestInfo?.showConfirmation && <GuestNameSummary guestInfo={guestInfo} />}

        {settings.isRegistration && settings.hasAttendanceQuestion && attendanceValue !== null && <AttendanceSummary isAttending={attendanceValue} />}

        {hasContactInfo && <ContactInfoSummary contactValues={contactValues} />}

        {hasSurveyAnswers && formData && (
          <SurveyResponsesSummary
            formData={formData}
            formValues={formValues}
          />
        )}
      </SpacingStack>
    </Box>
  );
};
